<template>
	<div style="background-color:#fafafa">
		<div class="container">
      <!-- <div style="height:130px"></div> -->
      <div class="bottom">
        <div class="left">
          广东经纬招标代理有限公司 All Rights Reserved. 
        </div>
        <div class="right">
          粤ICP备2022139271号-1
        </div>
      </div>
      
		</div>
	</div>

</template>

<script>
export default {
  name: "Banner",
  methods: {},
};
</script>

<style scoped>
.container {
    
  min-width: 1300px;
  max-width:1920px;
  margin:0px auto;
}
.bottom{
  height: 70px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #7f7f7f;
  

}
.left{
  margin-left: 190px;
  font-size: 10px;
}
.right {
  float: right;
  margin-right: 190px;
  justify-content: flex-end;
  display: flex;
    font-size: 10px;
  /* color: #2b2b2b; */
}
</style>